/**
 * Created by bas.
 */

'use strict';

var Emitter        = require('cjs-emitter'),
    gettextWrapper = require('mag-gettext'),
    daemon         = {
        triggers: [],
        hdmiOn: function () {
            this.triggers.forEach(function ( item ) {
                if ( typeof item.hdmiOn === 'function' ) {
                    item.hdmiOn();
                }
            });
        },
        hdmiOff: function () {
            this.triggers.forEach(function ( item ) {
                if ( typeof item.hdmiOff === 'function' ) {
                    item.hdmiOff();
                }
            });
        }
    },
    currInterval, standByTimer, wakeUpSources, gettext;


/**
 *  Update list of WakeUp sources which will be used to return STB from standby.
 */
function updateWakeUpSourcesList () {
    // Correct wake up sources to fix hdmi wake up reaction in deep standby mode
    if ( typeof gSTB.GetWakeUpSources === 'function' && (gSTB.SupportedWakeUpSources || []).indexOf(2) !== -1 ) {
        wakeUpSources = gSTB.GetWakeUpSources() || [];
        if ( currInterval === 0 && wakeUpSources.indexOf(2) !== -1 ) {
            wakeUpSources.splice(wakeUpSources.indexOf(2), 1);
            // hdmi reaction turned off so it's not a wake up src anymore
            gSTB.SetWakeUpSources(wakeUpSources);
        } else if ( currInterval !== 0 && wakeUpSources.indexOf(2) === -1 ) {
            wakeUpSources.push(2);
            // hdmi reaction turned on so add it as wake up src
            gSTB.SetWakeUpSources(wakeUpSources);
        }
    }
}


function init ( config ) {
    // apply user interval settings
    currInterval = Number(config.storage.getItem('timeValue'));
    if ( !currInterval && currInterval !== 0 ) {
        // migration
        currInterval = Number(JSON.parse(gSTB.GetEnv(JSON.stringify({varList: ['hdmi_event_delay']}))).result.hdmi_event_delay);
        // set default time (5 minutes)
        if ( !currInterval && currInterval !== 0 ) {
            currInterval = 300;
            config.storage.setItem('timeValue', currInterval);
        }
    }

    updateWakeUpSourcesList();

    // add listener for hdmi events
    window.stbEvent.addListener('media', function ( data ) {
        if ( data && data.code === 32 ) {
            // reset video mode and player resolution data
            window.system.emit('resetVideoMode');
            if ( currInterval ) {
                clearTimeout(standByTimer);
                if ( gSTB.GetStandByStatus() ) {
                    window.system.emit('standby', {action: 'off', scr: 'hdmi-reaction'});
                }
            }
        }
        if ( data && data.code === 33 && currInterval ) {
            clearTimeout(standByTimer);
            standByTimer = setTimeout(function () {
                if ( !gSTB.GetStandByStatus() ) {
                    window.system.emit('standby', {action: 'on', scr: 'hdmi-reaction'});
                }
            }, currInterval * 1000);
        }
    });
}


function build ( config ) {
    // default delay = 5 sec
    var timeToLabel = {
            0: gettext('Disabled'),
            5: gettext('Enabled'),
            300: gettext('5 minutes delay'),
            600: gettext('10 minutes delay')
        },
        result      = {
            content: [
                {
                    id: 'hdmiReaction',
                    parent: 'userInterface',
                    type: 'option',
                    name: gettext('HDMI event reaction'),
                    description: [
                        {
                            label: gettext('Interval') + ':',
                            value: timeToLabel[currInterval] || ''
                        }, {
                            label: '',
                            value: gettext('Device response to HDMI cable disconnections.')
                        }
                    ],
                    icon: 'theme-icon-hdmi',
                    data: {timeValue: 5},
                    saveImmediate: true,
                    render: config.api.renders.popupSelect,
                    prepareForRender: function ( data, callback ) {
                        callback([
                            {value: 0, name: gettext('Disabled'), selected: currInterval === 0},
                            {value: 5, name: gettext('Enabled'), selected: currInterval === 5},
                            {value: 300, name: gettext('5 minutes delay'), selected: currInterval === 300},
                            {value: 600, name: gettext('10 minutes delay'), selected: currInterval === 600}
                        ]);
                    },
                    prepareForSave: function ( value, callback ) {
                        //console.log('hdmi-reaction:was ' + config.storage.getItem('timeValue') + ' set to ' + value);
                        currInterval = value;
                        this.data.timeValue = currInterval;
                        updateWakeUpSourcesList();
                        callback(null, function () {
                            //console.log('call setInfo ' + typeof config.api.actions.setInfo);
                            config.api.actions.setInfo({
                                description: [
                                    {
                                        label: gettext('Interval') + ':',
                                        value: timeToLabel[currInterval] || ''
                                    }, {
                                        label: '',
                                        value: gettext('Device response to HDMI cable disconnections.')
                                    }
                                ]
                            });
                            if ( result && result.content && result.content[0] && result.content[0].description ) {
                                result.content[0].description[0].value = timeToLabel[currInterval] || '';
                            }
                        });
                    }
                }
            ]
        };

    return result;
}


function Client () {
    var self    = this,
        trigger = {};

    Emitter.call(this);

    trigger.hdmiOn = function () {
        if ( self.events['hdmiOn'] ) {
            try {
                self.emit('hdmiOn');
            } catch ( error ) {
                console.log('hdmi reaction plugin: error in one of hdmiOn listeners. ' + error);
            }
        }
    };
    trigger.hdmiOff = function () {
        if ( self.events['hdmiOff'] ) {
            try {
                self.emit('hdmiOff');
            } catch ( error ) {
                console.log('hdmi reaction plugin: error in one of hdmiOff listeners. ' + error);
            }
        }
    };

    daemon.triggers.push(trigger);

    /**
     * Stop this client and remove all it listeners. Use it for cleanup before application exit.
     */
    this.destroy = function () {
        daemon.triggers.splice(daemon.triggers.indexOf(trigger), 1);
        this.events = {};
    };
}


Client.prototype = Object.create(Emitter.prototype);
Client.prototype.constructor = Client;


module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            init(config);
            callback();
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, new Client());
    },
    onSettingsInit: function ( config, callback ) {
        callback(null, build(config));
    }
};
